module.exports = __webpack_public_path__ + "img/giveup.e2584c44.svg";